import {useState} from 'react';
import {SearchInput} from '../../navigation/seacrhField';

export default function DeleteEvent() {
  const [isDeleted, setIsDeleted] = useState<boolean | null>(null);
  // const getEvent = useEventListStore(state => state.getEventById);
  // const deleteEvent = useEventListStore(state => state.deleteEvent);

  const handleSearch = (id: string) => {
    // if (getEvent(id)) {
    // deleteEvent(id);
    // setIsDeleted(true);
    // } else {
    setIsDeleted(false);
    // }
  };
  return (
    <>
      <h1> Delete Event</h1>
      <SearchInput onSearch={handleSearch} />
      <p>
        {isDeleted === true && 'Event Deleted'}
        {isDeleted === false && 'Invalid Id'}
      </p>
    </>
  );
}
